lmApp
  .directive('lmEditLive', [function () {
    return {
      restrict: 'E',
      replace: true,
      controller: 'LmEditLiveController',
      templateUrl: 'lm-asset-edit/live/edit-live.tpl.html'
    };
  }]);

lmApp
  .controller('LmEditLiveController', ['$scope', '$rootScope', '$templateCache', '$compile', '$q', '$timeout', 'MetadataService', 'AssetService', 'ToastService', 'GenreResource', 'CategoryResource', 'EPGChannelResource', 'ProviderResource', 'AssetResource', 'SubscriptionPlanResource', 'ContentNodeResource', 'ValidatorService',
    function ($scope, $rootScope, $templateCache, $compile, $q, $timeout, MetadataService, AssetService, ToastService, GenreResource, CategoryResource, EPGChannelResource, ProviderResource, AssetResource, SubscriptionPlanResource, ContentNodeResource, ValidatorService) {
      $scope.channel = {
        id: 0,
        extid: '',
        type: 'channel',
        name: '',
        description: '',
        rotationStart: moment.utc().subtract(1, 'day'),
        rotationFinish: moment.utc().add(1, 'year'),
        lcn: '',
        epg: {
          id: 0,
          title: '',
        },
        provider: {},
        adult: false,
        categories: [],
        genres: [],
        poster: {
          state: '',
          url: '',
          source: ''
        },
        streams: [],
        catchup: {
          id: 0,
          source: '',
          depth: 0,
        },
        streamResources: [],
        packages: [],
        free: false,
        billingType: 'packages', // packages, free, plans
        plans: [],
        vastId: '',
      };

      $scope.genres = [];
      $scope.categories = [];
      $scope.providers = [];
      $scope.epgChannels = [];
      $scope.packages = [];
      $scope.plans = [];

      var saved = {};
      var savedPlans = {};

      if ($scope.asset.id && $scope.asset.id > 0) {
        $scope.channel.id = $scope.asset.id;
        $scope.channel.free = $scope.asset.free || false;
        $rootScope.showLinearProgress('#modalLoader');
        $scope.$parent.loading = true;

        var params = {};
        params['id[eq]'] = $scope.asset.id;
        params['$expand'] = 'resources(url),categories,genres,packages,provider,epg';
        AssetResource.get(params).$promise
            .then(function (result) {
              if (result.length) {
                processAsset(result[0]);
                saved = angular.copy(result[0]);
              } else {
                ToastService.Small({
                  title: 'Error getting channel',
                  color: 'red',
                  icon: 'cloud-check'
                }, 1000 * 6);
                $scope.close();
              }
              $rootScope.hideLinearProgress('#modalLoader');
              $scope.$parent.loading = false;
            })
            .catch(function (reason) {
              console.log('error', reason)
              ToastService.Small({
                title: 'Error getting channel',
                color: 'red',
                icon: 'cloud-check'
              }, 1000 * 6);
              $rootScope.hideLinearProgress('#modalLoader');
              $scope.$parent.loading = false;
              $scope.close();
            });
      }

      var processProvider = function(provider) {
        if (!provider) return {};
        return {
          id: provider.id,
          title: provider.name
        }
      };

      var processCategory = function(category) {
        return {
          id: category.id,
          title: category.name
        };
      };

      var processGenre = function(genre) {
        return {
          id: genre.id,
          title: genre.name
        };
      };

      var processPackage = function(pack) {
        return {
          id: pack.id,
          title: pack.name
        };
      };

      var processAsset = function(asset) {
        $scope.channel.extid = asset.ext_id;
        $scope.channel.name = asset.name;
        $scope.channel.description = asset.description;
        $scope.channel.rotationStart = moment(asset.rotation_start);
        $scope.channel.rotationFinish = moment(asset.rotation_finish);
        $scope.channel.lcn = parseInt(asset.lcn);
        $scope.channel.provider = processProvider(asset.provider);
        $scope.channel.adult = asset.adult || false;
        $scope.channel.vastId = asset.vast_id || '';
        var categories = asset.categories || [];
        $scope.channel.categories = categories.map(processCategory);
        var genres = asset.genres || [];
        $scope.channel.genres = genres.map(processGenre);
        var packages = asset.packages || [];
        $scope.channel.packages = packages.map(processPackage);

        if (asset.epg) {
          $scope.channel.epg.id = asset.epg.id
          $scope.channel.epg.title = asset.epg.ext_id
        }

        if (asset.resources) {
          for (var i = 0; i < asset.resources.length; i++) {
            var r = asset.resources[i]
            if (r.type === 'picture') {
              $scope.channel.poster.state = r.state;
              $scope.channel.poster.url = r.url;
              $scope.channel.poster.source = r.source;
              continue
            }
            if (r.category === 'catchup') {
              $scope.channel.catchup.id = r.id;
              $scope.channel.catchup.source = r.source;
              $scope.channel.catchup.depth = parseInt(r.catchup_depth) || 0;
            }
            var pr = {
              id: r.id,
              type: r.type.toUpperCase(),
              group: r.group_id,
              state: r.state,
              deployer: r.deployer,
              preparer: r.preparer,
              added: r.create_time,
              private: r.private || false,
              URL: r.source,
              category: r.category,
              tags: '',
              depth: parseInt(r.catchup_depth) || 0
            }
            if (r.deployer_args && r.deployer_args.cdn_tag) {
              pr.tags = r.deployer_args.cdn_tag;
            }
            if (r.type === 'dash-live' || r.type === 'hls-live' || r.type === 'shoutcast' || r.type === 'hls-live-protected' || r.type === 'dash-live-protected') {
              $scope.channel.streams.push(pr)
            }
            $scope.channel.streamResources.push(pr)
          }
        }
        if (asset.free) {
          $scope.channel.free = true;
          $scope.channel.billingType = 'free';
        }
      };


      var getMeta = function() {
        EPGChannelResource.get().$promise
            .then(function (epgChannels) {
              var epgChannelList = [];
              for (var i = 0; i < epgChannels.length; i++) {
                var epgChannel = epgChannels[i];
                epgChannelList.push({
                  id: epgChannel.id,
                  title: epgChannel.ext_id
                });
              }
              $scope.epgChannels = epgChannelList;
            })
            .catch(function (reason) {
              $rootScope.debugInfo(reason, 'silent');
            });

        GenreResource.get().$promise
            .then(function (genres) {
              var genreList = [];
              for (var i = 0; i < genres.length; i++) {
                var genre = genres[i];
                genreList.push({
                  id: genre.id,
                  title: genre.name
                });
              }
              $scope.genres = genreList;
            })
            .catch(function (reason) {
              $rootScope.debugInfo(reason);
            });

        CategoryResource.get().$promise
            .then(function (categories) {
              var categoryList = [];
              for (var i = 0; i < categories.length; i++) {
                var category = categories[i];
                var processed = {
                  id: category.id,
                  title: category.name
                };
                categoryList.push(processed);
                if ($scope.channel.id === 0 && category.ext_id === 'tv') {
                  $scope.channel.categories.push(processed);
                }
              }
              $scope.categories = categoryList;
            })
            .catch(function (reason) {
              $rootScope.debugInfo(reason);
            });

        ProviderResource.get().$promise
            .then(function (providers) {
              var providerList = [];
              for (var i = 0; i < providers.length; i++) {
                var provider = providers[i];
                providerList.push({
                  id: provider.id,
                  title: provider.name
                });
              }
              $scope.providers = providerList;
            })
            .catch(function (reason) {
              $rootScope.debugInfo(reason, 'silent');
            });

        AssetResource.get({'type[in]': 'package'}).$promise
            .then(function (packages) {
              var packageList = [];
              for (var i = 0; i < packages.length; i++) {
                var p = packages[i];
                packageList.push({
                  id: p.id,
                  title: p.name
                });
              }
              $scope.packages = packageList;
            })
            .catch(function (reason) {
              $rootScope.debugInfo(reason, 'silent');
            });


        SubscriptionPlanResource.get({'$expand': 'assets'}).$promise
            .then(function (plans) {
              var planList = [];
              for (var i = 0; i < plans.length; i++) {
                var p = plans[i];
                var assets = p.assets || [];
                var processed = {
                  id: p.id,
                  title: p.name,
                  assets: assets
                };
                planList.push(processed);
                if ($scope.channel.id > 0) {
                  for (var j = 0; j < assets.length; j++) {
                    if (assets[j].id === $scope.channel.id) {
                      $scope.channel.plans.push(processed);
                      break;
                    }
                  }
                  savedPlans = angular.copy($scope.channel.plans);
                }
              }

              if ($scope.channel.id > 0 && !$scope.channelfree && $scope.channel.plans.length) {
                $scope.channel.billingType = 'plans';
              }
              $scope.plans = planList;
            })
            .catch(function (reason) {
              $rootScope.debugInfo(reason, 'silent');
            });
      };

      getMeta();

      $scope.setCatchupOptions = function () {
        var hlsFound = false
        for (var i = 0; i < $scope.channel.streamResources.length; i++) {
          var r = $scope.channel.streamResources[i]
          if (r.type.toLowerCase() === 'hls-live') {
            hlsFound = true
            if (!$scope.channel.catchup.source) {
              $scope.channel.catchup.source = r.URL
            }
            break
          }
        }

       // if (!hlsFound) return;

        MetadataService.Catchup2.ChangeValue($scope.channel, $scope);
      };

      $scope.cdnTags = [];
      $scope.getCDNTags = function () {
        return ContentNodeResource.get().$promise
            .then(function (origins) {
              for (var i = 0; i < origins.length; i++) {
                var origin = origins[i];
                if (!origin.cdn) {
                  continue
                }
                for (var j = 0; j < origin.cdn.length; j += 1) {
                  if (!origin.cdn[j].tag) continue;
                  $scope.cdnTags.push(origin.cdn[j].tag)
                }
              }
            })
            .catch(function (reason) {
              $rootScope.debugInfo(reason);
            });
      };
      $scope.getCDNTags();

      $scope.openMediaManager = function (type, resource) {
        if ($scope.loading) return;
        MetadataService.MediaManager2($scope.channel, $scope, type, resource, $scope.cdnTags);
      };

      $scope.deleteStream = function($index) {
        $scope.channel.streamResources.splice($index, 1);
      };

      var normStreamResourceToJson = function (stream) {
        var resource = {
          type: stream.type.toLowerCase(), // dash-live , hls-live, shoutcast
          category: stream.category,
          group_id: stream.group,
          source: stream.URL,
          preparer: stream.preparer,
          private: stream.private,
          deployer: stream.deployer,
          deployer_args: {},
          catchup_depth: parseInt(stream.depth) || 0
        };
        if (stream.tags) {
          resource.deployer_args.cdn_tag = stream.tags
        }
        return resource
      };

      var normChannelToJson = function(channel) {
        var processed = {
          ext_id: 'personal:' + translit(channel.name) + (channel.lcn || '') + ':' + CryptoJS.MD5(channel.name + (channel.year || '')).toString(CryptoJS.enc.Hex) + ':' + guid(),
          type: 'channel',
          name: _.trim(channel.name),
          description: _.trim(channel.description),
          lcn: parseInt(channel.lcn) || 0,
          categories: channel.categories,
          genres: channel.genres,
          packages: channel.packages,
          adult: channel.adult,
          rotation_start: channel.rotationStart.format(),
          rotation_finish: channel.rotationFinish.format(),
          resources: [],
          free: false,
          plans: [],
          vast_id: channel.vastId,
          provider: channel.provider,
          epg: channel.epg,
        };
        if (channel.poster.source) {
          processed.resources.push({
            type: 'picture',
            category: 'poster_blueprint',
            group_id: 'picture',
            source: channel.poster.source,
            preparer: 'passthrough',
            deployer: 'origin'
          });
        }
        for (var i = 0; i < channel.streamResources.length; i++) {
          processed.resources.push(normStreamResourceToJson(channel.streamResources[i]));
        }
        if (channel.billingType === 'free') {
          processed.free = true;
          processed.plans = [];
        }
        if (channel.billingType === 'plans') {
          processed.plans = channel.plans;
        }
        return processed;
      };

      var isAssetValid = function() {
        $scope.channelValidateErrors = {};

        var valid = true;
        if (!_.trim($scope.channel.name)) {
          $scope.channelValidateErrors.name = true;
          valid = false;
        }
        if ($scope.channel.lcn && (!ValidatorService.Numerical($scope.channel.lcn) || $scope.channel.lcn < 0)) {
          $scope.channelValidateErrors.lcn = true;
          valid = false;
        }
        return valid;
      };

      $scope.$parent.createFn = function () {
        if (!isAssetValid()) return;

        $rootScope.showLinearProgress('#modalLoader');
        $scope.$parent.loading = true;

        var newChannel = normChannelToJson($scope.channel);
        if (!newChannel.provider.id) {
          delete newChannel.provider;
        }
        if (!newChannel.epg.id) {
          delete newChannel.epg;
        }

        AssetResource.create(newChannel).$promise
            .then(function (response) {
              if ($scope.channel.plans.length > 0) {
                for (var i = 0; i < $scope.channel.plans.length; i++) {
                  var assets = $scope.channel.plans[i].assets;
                  assets.push({id: response.data.id});
                  SubscriptionPlanResource.update({id: $scope.channel.plans[i].id}, {assets: assets}).$promise
                      .then(function (response) {
                      })
                      .catch(function (reason) {
                        $rootScope.debugInfo(reason, 'silent');
                      });
                }
              }

              ToastService.Small({
                title: 'Channel: <b class="tc-white">' + $scope.channel.name + '</b> successfully created',
                color: 'green',
                icon: 'cloud-check'
              }, 1000 * 6);

              $rootScope.hideLinearProgress('#modalLoader');
              $scope.$parent.loading = false;

              $scope.close(response.data.id);

            })
            .catch(function (reason) {
              $rootScope.hideLinearProgress('#modalLoader');
              $scope.$parent.loading = true;
              $scope.close();
              ToastService.Small({
                title: 'Failed to create channel: ' + _.get(reason, 'data.error.message', 'server error'),
                color: 'red',
                icon: 'delete'
              }, 30 * 1000);
            });
      };

      var compareResources = function(updated) {
        var sourceResourceMap = {};
        if (saved.resources) {
          for (var i = 0; i < saved.resources.length; i++) {
            var r = saved.resources[i];
            var tags = ''
            if (r.deployer_args && r.deployer_args.cdn_tag) {
              tags = r.deployer_args.cdn_tag;
            }
            var depth = 0
            if (r.catchup_depth) {
              depth = r.catchup_depth
            }
            if (!r.private) r.private = false;
            var key = (r.type + r.category + r.private + r.deployer + tags + depth).toLowerCase();
            sourceResourceMap[key] = r;
          }
        }

        var newResources = [];
        for (var i = 0; i < updated.resources.length; i++) {
          var r = updated.resources[i];
          var tags = ''
          if (r.deployer_args && r.deployer_args.cdn_tag) {
            tags = r.deployer_args.cdn_tag;
          }
          var depth = 0
          if (r.catchup_depth) {
            depth = r.catchup_depth
          }
          if (!r.private) r.private = false;
          var key = (r.type + r.category + r.private + r.deployer + tags + depth).toLowerCase();
          if (!sourceResourceMap.hasOwnProperty(key)) {
            newResources.push(r);
          } else {
            if (r.source === sourceResourceMap[key].source
                && r.private === sourceResourceMap[key].private
                && r.deployer === sourceResourceMap[key].deployer
                && sourceResourceMap[key].state !== 'deployment-error') {
              newResources.push(sourceResourceMap[key]);
            } else {
              newResources.push(r);
            }
          }
        }
        return newResources;
      };

      var comparePlans = function(updated) {
        var diff = {
          add: {},
          delete: {}
        };

        var sourcePlanMap = {};
        for (var i = 0; i < savedPlans.length; i++) {
          sourcePlanMap[savedPlans[i].id] = true;
        }

        for (var i = 0; i < updated.plans.length; i++) {
          var key = updated.plans[i].id;
          if (sourcePlanMap.hasOwnProperty(key)) {
            delete sourcePlanMap[key];
          } else {
            diff.add[key] = true;
          }
        }
        for (var key in sourcePlanMap) {
          diff.delete[key] = true;
        }
        return diff;
      };

      $scope.$parent.updateFn = function (asset) {
        if (!isAssetValid()) return;

        $rootScope.showLinearProgress('#modalLoader');
        $scope.$parent.loading = true;

        var updated = normChannelToJson($scope.channel);
        updated.resources = compareResources(updated);

        AssetResource.update({id: $scope.channel.id}, updated).$promise
            .then(function (response) {
              var planDiff = comparePlans(updated);

              for (var i = 0; i < $scope.plans.length; i++) {
                var plan = $scope.plans[i];
                var assets = angular.copy(plan.assets);
                if (planDiff.add.hasOwnProperty(plan.id)) {
                  assets.push({id: $scope.channel.id});
                  SubscriptionPlanResource.update({id: plan.id}, {assets: assets}).$promise
                      .then(function (response) {})
                      .catch(function (reason) {
                        $rootScope.debugInfo(reason, 'silent');
                      });
                }
                if (planDiff.delete.hasOwnProperty(plan.id)) {
                  var newList = [];
                  for (var j = 0; j < assets.length; j++) {
                    if (assets[j].id !== $scope.channel.id) {
                      newList.push({id: assets[j].id});
                    }
                  }
                  SubscriptionPlanResource.update({id: plan.id}, {assets: newList}).$promise
                      .then(function (response) {})
                      .catch(function (reason) {
                        $rootScope.debugInfo(reason, 'silent');
                      });
                }
              }

              ToastService.Small({
                title: 'Channel <b class="tc-white">' + $scope.channel.name + '</b> successfully updated',
                color: 'green',
                icon: 'cloud-check'
              }, 1000 * 6);

              $rootScope.hideLinearProgress('#modalLoader');
              $scope.$parent.loading = false;

              $scope.close(response.data.id);

            })
            .catch(function (reason) {
              $rootScope.showLinearProgress('#modalLoader');
              $scope.$parent.loading = true;
              ToastService.Small({
                title: 'Failed to update channel: ' + _.get(reason, 'data.error.message', 'server error'),
                color: 'red',
                icon: 'cloud-outline-off'
              }, 30 * 1000);
              $rootScope.debugInfo(reason);
            });
      }

    }]);
